import React, { FunctionComponent } from 'react';
import { useReactiveVar } from '@apollo/client';
import IFeature from '../../../../../../../model/IFeature';
import { selectedCurrencyVar } from '../../../../../../../../gqlCommon/graphql/cache';
import Price from '../../../../../../../../gqlCommon/components/presentation/Price';
import useSelectedCurrencyPrice from '../../../../../../../../gqlCommon/hooks/currency/useSelectedCurrencyPrice';
import { usePersistedCurrencyPreference } from '../../../../../../../../gqlCommon/hooks/currency/usePersistedCurrencyPreference';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';
import usePlatformConfig from '../../../../../../../../common/react/usePlatformConfig';
import summaryStyles from '../../../summarySection/SummaryStyles';
import useCustomizeCarContext from '../../../../../../../hooks/useCustomizeCarContext';

export interface ISelectedFeaturePriceProps {
  feature: IFeature;
}

const SelectedFeaturePrice: FunctionComponent<ISelectedFeaturePriceProps> = ({ feature }) => {
  const { selectedCurrencyPrice } = useSelectedCurrencyPrice(feature.prices);
  const { loading } = useCustomizeCarContext();
  const selectedCurrency = useReactiveVar(selectedCurrencyVar);
  const styles = summaryStyles();
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();

  return (
    <Price
      loading={loading}
      price={selectedCurrencyPrice}
      currency={selectedCurrency}
      className={styles.optionPrice}
      priceDisplayType={isSecondaryCurrencyDisplay ? PriceDisplayType.SECONDARY : PriceDisplayType.PRIMARY}
      decimals={
        isSecondaryCurrencyDisplay
          ? priceDisplay.secondaryOptions.decimalScale
          : priceDisplay.primaryOptions.decimalScale
      }
    />
  );
};

export default SelectedFeaturePrice;
